import React, { useState, useEffect } from 'react'
import { Box, IconButton } from '@material-ui/core'
import Icon from '@mdi/react'
import Lightbox from 'react-image-lightbox'
import { mdiImagePlusOutline } from '@mdi/js'
import { arrayBufferToBase64 } from 'web/src/utils/bufferToBase64'
import { useSelector } from 'react-redux'
import { useStyles } from './styles'
import Loader from 'web/src/app/root/components/common/loader'
import { ImagePlusIcon } from 'lucide-react'

export const AvatarView = ({
    onClick,
    imagesForUpload,
    setIsModalOpen,
    loading,
    permissions
}) => {
    const { theme } = useSelector(state => state.main)
    const classes = useStyles(theme)
    const [images, setImages] = useState([])
    const [showLightBox, setShowLightBox] = useState(false)
    const [imageIndex, setImageIndex] = useState(0)

    useEffect(() => {
        if (imagesForUpload.length) {
            imagesForUpload.forEach(image => {
                if (image?.Body) {
                    return setImages(prevImage => [
                        ...prevImage,
                        `data:image/jpeg;base64,${arrayBufferToBase64(
                            image.Body.data
                        )}`
                    ])
                }

                const reader = new FileReader()
                reader.readAsDataURL(image)
                reader.onloadend = function() {
                    setImages([...images, reader.result])
                }
            })
        }

        return () => setImages([])
    }, [imagesForUpload])

    return (
        <Box className={classes.avatarContainer}>
            {loading ? (
                <Loader />
            ) : (
                <IconButton
                    disabled={!permissions.updateDevice}
                    onClick={e => {
                        if (permissions.updateDevice) {
                            onClick()
                        }
                    }}
                >
                    <ImagePlusIcon style={{ opacity: 1 }} size={30} />
                </IconButton>
            )}
            {showLightBox && (
                <Lightbox
                    mainSrc={images[imageIndex]}
                    nextSrc={images[(imageIndex + 1) % images.length]}
                    prevSrc={
                        images[(imageIndex + images.length - 1) % images.length]
                    }
                    onCloseRequest={() => setShowLightBox(false)}
                    onMovePrevRequest={() =>
                        setImageIndex(
                            (imageIndex + images.length - 1) % images.length
                        )
                    }
                    onMoveNextRequest={() =>
                        setImageIndex((imageIndex + 1) % images.length)
                    }
                />
            )}

            {!!images.length && (
                <>
                    {!loading && (
                        <img
                            style={{
                                position: 'absolute',
                                width: 'inherit',
                                height: 'inherit',
                                borderRadius: 'inherit',
                                cursor: 'pointer',
                                objectFit: 'contain'
                            }}
                            src={images[0]}
                            onClick={e => {
                                e.preventDefault()
                                setShowLightBox(true)
                            }}
                        />
                    )}
                    {permissions.updateDevice && !loading && (
                        <Box
                            style={{
                                cursor: 'pointer',
                                position: 'absolute',
                                right: 1,
                                top: 1,
                                width: 30,
                                height: 30,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                backgroundColor: theme.background,
                                border: `0.5px solid ${theme.secondary}`,
                                '&:hover': {
                                    backgroundColor: theme.secondary
                                },
                                zIndex: 1
                            }}
                        >
                            <ImagePlusIcon
                                size={20}
                                className={`${classes.iconStyles2}`}
                                onClick={e => {
                                    e.preventDefault()
                                    setIsModalOpen(true)
                                }}
                            />
                        </Box>
                    )}
                </>
            )}
        </Box>
    )
}
